"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DS_BUTTON_STATE = void 0;
const colors_1 = require("../styles/colors");
exports.DS_BUTTON_STATE = {
    '&:hover': {
        background: '#00CDFD',
    },
    '&:focus': {
        border: '#1A2981 solid 1px',
    },
    '&:disabled': {
        background: '#E5E5E5',
        color: colors_1.$primaryWhite,
    },
};
